import React from "react";
import { getCookie } from "@/utils";

const bootLoadingCaptions: Record<string, string> = {
    tr: "Başlatılıyor",
    en: "Starting",
};

const getBootLoadingCaption = () => {
    const lang = (getCookie("accept-language") || navigator.language || "en").toLowerCase();
    return lang.startsWith("tr") ? bootLoadingCaptions.tr : bootLoadingCaptions.en;
};

export const LoadingPage: React.FC = () => {
    const theme = new URLSearchParams(window.location.search).get("theme");
    const isMebkit = window.location.origin.includes("mebkit");


    return (
        <div
            style={{
                width: "100%",
                height: "100%",
                background: "#ffffff",
                position: "absolute",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                ...(theme === "maarif" ? { "--loading-dot-color": "hsl(195, 44%, 51%)" } : {}),
            } as React.CSSProperties}
        >
            <span id="logo_loading_screen">
                {theme === "maarif" ? (
                    <img src={`${import.meta.env.BASE_URL}media/maarif_logo.png`} alt="Maarif" width="170" />
                ) : isMebkit ? (
                    <img src={`${import.meta.env.BASE_URL}mebkit/icon.png`} alt="Mebkit" width="170" />
                ) : (
                    <img
                        src={`${import.meta.env.BASE_URL}riders/Riders_AnimatedLogo_AllGreen_v02.gif`}
                        alt="Riders"
                        width="720"
                    />
                )}
            </span>
            <div className="loading-caption">{getBootLoadingCaption()}</div>
            <div style={{ display: "flex", marginTop: "20px" }}>
                <div className="dot dot--one" />
                <div className="dot dot--two" />
                <div className="dot dot--three" />
            </div>
        </div>
    );
};

export default LoadingPage;